export default __webpack_public_path__ + "static/media/player-pause.768632d7.svg";